module.exports = __webpack_public_path__ + "static/media/tutorial-03.366ffd23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/tutorial-03.jpg
// module id = 337
// module chunks = 0